import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ChunkErrorService } from './services/chunk-error.service';

const chunkErrorMessages = [
  /Loading chunk [\w\-.]+/i,
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
];

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly chunkErrorService = inject(ChunkErrorService);

  handleError(error: unknown): void {
    // eslint-disable-next-line no-console
    console.error(error);
    if (error instanceof Error) {
      if (chunkErrorMessages.some(regex => regex.test(error.message))) {
        this.chunkErrorService.emit();
      }
    }
  }
}
